import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Checkbox from "@mui/material/Checkbox";
import Chip from "@mui/material/Chip";
import type { ProxyListItem } from "./useProxyList";
import { formatDate } from "../../lib/FormatDate";

interface ProxyDataGridProps {
  items: ProxyListItem[];
  selectedIds: Set<string>;
  onSelectionChange: (ids: Set<string>) => void;
}

export function ProxyDataGrid(props: ProxyDataGridProps) {
  const { items, selectedIds, onSelectionChange } = props;

  const allSelected = items.length > 0 && items.every((item) => selectedIds.has(item.id));

  const toggleAll = () => {
    if (allSelected) {
      onSelectionChange(new Set());
    } else {
      onSelectionChange(new Set(items.map((item) => item.id)));
    }
  };

  const toggleOne = (id: string) => {
    const next = new Set(selectedIds);
    if (next.has(id)) {
      next.delete(id);
    } else {
      next.add(id);
    }
    onSelectionChange(next);
  };

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell padding="checkbox">
              <Checkbox
                checked={allSelected}
                indeterminate={selectedIds.size > 0 && !allSelected}
                onChange={toggleAll}
              />
            </TableCell>
            <TableCell>Host</TableCell>
            <TableCell>Port</TableCell>
            <TableCell>Статус</TableCell>
            <TableCell>Группа</TableCell>
            <TableCell>Последняя проверка</TableCell>
            <TableCell>Дата добавления</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item) => (
            <TableRow key={item.id} hover>
              <TableCell padding="checkbox">
                <Checkbox
                  checked={selectedIds.has(item.id)}
                  onChange={() => toggleOne(item.id)}
                />
              </TableCell>
              <TableCell>{item.host}</TableCell>
              <TableCell>{item.port}</TableCell>
              <TableCell>
                <Chip
                  label={item.status === "active" ? "Active" : "Inactive"}
                  color={item.status === "active" ? "success" : "default"}
                  size="small"
                />
              </TableCell>
              <TableCell>
                {item.group === null ? (
                  <Chip label="Без группы" color="default" size="small" variant="outlined" />
                ) : (
                  <Chip label={item.group} color="primary" size="small" variant="outlined" />
                )}
              </TableCell>
              <TableCell>{formatDate(item.lastCheckedAt)}</TableCell>
              <TableCell>{formatDate(item.createdAt)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
